import { useCallback, useEffect } from 'react';
import { getOrganisationDomain } from '../utils';

export const useConsentManager = () => {
  const getCDID = useCallback(() => {
    switch (getOrganisationDomain()) {
      case 'ruhrnachrichten1':
      case 'ruhr_nachrichten':
        return '3c8dd508c2589';
      case 'buzz04ruhr_nachrichten':
        return '88c6f91892487';
      default:
        return null;
    }
  }, []);

  useEffect(() => {
    const cdid = getCDID();

    if (!cdid) {
      return;
    }

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://cdn.consentmanager.net/delivery/js/semiautomatic.min.js';
    script.setAttribute('data-cmp-ab', '1');
    script.setAttribute('data-cmp-cdid', cdid);
    script.setAttribute('data-cmp-host', 'd.delivery.consentmanager.net');
    script.setAttribute('data-cmp-cdn', 'cdn.consentmanager.net');
    script.setAttribute('data-cmp-codesrc', '0');
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [getCDID]);
};
